// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3fjbH{color:#777}._3fjbH:focus,._3fjbH:hover{color:#000}", ""]);
// Exports
exports.locals = {
	"button": "_3fjbH"
};
module.exports = exports;
